import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { BrandMark } from '@/components/layout/BrandMark';
import { BRAND } from '@/config/brand';
import { ONLINE_BOOKING_ENABLED } from '@/config/featureFlags';
import { ToastViewport } from '@/components/ui/Toast';

/**
 * Public (unauthenticated) layout for the customer-facing site — home + booking.
 * Break Point Club identity, gold-green theme, no operator chrome.
 */
export function PublicShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-base">
      <header className="sticky top-0 z-30 border-b border-line bg-base/80 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6">
          <Link to="/" className="focus-ring rounded-md" aria-label="Break Point Club home">
            <BrandMark size="sm" />
          </Link>
          <nav className="flex items-center gap-1.5 sm:gap-3">
            {ONLINE_BOOKING_ENABLED && (
              <Link
                to="/book"
                className="focus-ring rounded-lg px-3 py-2 text-sm font-medium text-content hover:text-brand"
              >
                Book a table
              </Link>
            )}
            <Link
              to="/login"
              className="focus-ring rounded-lg border border-line px-3 py-2 text-sm text-muted hover:border-brand/40 hover:text-content"
            >
              Staff login
            </Link>
          </nav>
        </div>
      </header>

      <main className="flex-1">{children}</main>

      <footer className="border-t border-line bg-surface/40">
        <div className="mx-auto flex max-w-6xl flex-col items-center gap-3 px-4 py-10 text-center sm:px-6">
          <BrandMark size="md" subtitle />
          <p className="mt-2 text-sm text-muted">{BRAND.tagline}</p>
          <p className="text-xs text-subtle">
            © {new Date().getFullYear()} {BRAND.name}. Per-minute play · pay at the counter.
          </p>
        </div>
      </footer>

      <ToastViewport />
    </div>
  );
}

export default PublicShell;
